import api from '@/api';

export const actions = {

    adminMailingsSend({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'mailings/send', method: 'POST', data: data })
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

};
